module.exports = __webpack_public_path__ + "static/img/silver.1e0ded2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/silver.png
// module id = BR21
// module chunks = 1